import axios from "axios";

// export const baseUrl = "http://localhost:8091/";
// export const baseUrl="http://207.180.238.122:8091/";
export const baseUrl="/";

export const loginApi = async (data) => {
    const response = await axios.post(`${baseUrl}api/v1/login`, data);
    return response;
}

export const getClientServicesApi = async (token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/get-client-services`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const fetchRevenueApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/fetch-revenue`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const fetchLiveDataApi = async (service_id, token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/live-revenue?service_id=${service_id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const fetchHourlyDataApi = async (token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/hourly-update-services`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const fetchAllServiceRevenueApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/all-service-revenue`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}


export const fetchAllServiceLiveRevenueApi = async (token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/all-service-live-revenue`, null, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}


// Promotion API

export const fetchPublishersApi = async (service_id, token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/promotion/get-publishers?service_id=${service_id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const fetchAllPublishersApi = async (token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/promotion/all-publishers`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const addPublisherApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/promotion/add-publisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const editPublisherApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/promotion/edit-publisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const deletePublisherApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/promotion/delete-publisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const togglePublisherApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/promotion/toggle-publisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const dummyHitApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/promotion/dummy-hit`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const fetchPublisherTrafficApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/promotion/fetch-traffic`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const fetchPublisherSubscriptionApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/promotion/fetch-subscription`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const getPromoClientServicesApi = async (token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/promotion/get-services`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

// Advertiser Apis

export const getAvertiserPromoClientServicesApi = async (token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/advertiser/get-services`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const fetchAdvertisersApi = async (service_id, token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/advertiser/get-publishers?service_id=${service_id}`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const deleteAdvertiserPublisherApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/advertiser/delete-publisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const toggleAdvertiserApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/advertiser/toggle-publisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const addAvertiserApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/advertiser/add-publisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const editAvertiserApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/advertiser/edit-publisher`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const fetchAllAdvertisersApi = async (token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/advertiser/all-publishers`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const fetchAvertiserTrafficApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/advertiser/fetch-traffic`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const fetchAvertiserSubscriptionApi = async (data, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/advertiser/fetch-subscription`, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}